import { useDispatch } from 'react-redux';

import { store } from './store';

export function useThunkDispatch() {
  return useDispatch<typeof store.dispatch>();
}
